<template>
  <div class="w-full bg-white">
    
    <PopUpView v-if="this.openModal == true" 
        @sendClose="closeModalView" />

    <div class="min-h-screen px-4 md:px-6 md:max-w-7xl mx-auto flex items-center justify-center">
      <div class="w-full">
        <div class="text-3xl md:text-5xl text-center mb-5 md:mb-10 font-medium">Datamap Search</div>
        <div class="px-4 w-full md:w-3/5 flex relative drop-shadow-sm mx-auto">
          <form method="GET" action="search" @submit="formSubmit" class="w-full">
            <input ref="input" :value="searchInput" name="q" @input="$emit('update:searchInput', $event.target.value)"
              placeholder="국내 모든 공공데이터를 한 번에 찾아보세요."
              class="w-full pl-4 pr-8 md:px-8 text-xs md:text-base py-4 bg-white focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-2 border"/>
            <button ref="button" type="submit" class="absolute right-7 py-4">
              <svg xmlns="http://www.w3.org/2000/svg" ref="button" type="submit" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
              </svg>
            </button>
          </form>
        </div>
        <div class="hidden max-w-fit mx-auto md:flex pt-7 gap-x-6 text-sm text-gray-700">
          <div>추천 검색어: </div>
          <div>
            <router-link to="/search?q=미세먼지" class="underline mr-4">미세먼지</router-link>
            <router-link to="/search?q=코로나19" class="underline mr-4">코로나19</router-link>
            <router-link to="/search?q=주소" class="underline mr-4">주소</router-link>
            <router-link to="/search?q=주유소" class="underline mr-4">주유소</router-link>
            <router-link to="/search?q=인구" class="underline mr-4">인구</router-link>
          </div>
        </div>
        <div class="md:hidden mt-5 mx-auto flex flex-col items-center justify-center text-sm text-gray-700">
          <div class="mb-1.5">추천 검색어: </div>
          <div>
            <router-link to="/search?q=미세먼지" class="underline mr-4">미세먼지</router-link>
            <router-link to="/search?q=코로나19" class="underline mr-4">코로나19</router-link>
            <router-link to="/search?q=주소" class="underline mr-4">주소</router-link>
            <router-link to="/search?q=주유소" class="underline mr-4">주유소</router-link>
            <router-link to="/search?q=인구" class="underline mr-4">인구</router-link>
          </div>
        </div>
        
        
      </div>
    </div>
  </div>
</template>

<script>
import PopUpView from '@/components/PopUpView.vue'
export default {
  name: 'IndexView',
  components: {
    PopUpView,
  },
  props: {
    searchInput: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      openModal: true,
    }
  },
  methods: {
    formSubmit(e) {
      if (guardEvent(e)) {
          const target = this.searchInput
          const { location } = this.$router.resolve('/' + target)
          this.$router.push(location)
          e.preventDefault()
      }
    },
    closeModalView(data) {
      this.openModal = data
    },
  }
}

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return false
  }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) {
    return false
  }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) {
    return false
  }
  return true
}
</script>
